import { createApp } from 'vue';
import TiffToPngConverter from '../Components/TiffToPngConverter.vue';

const root = document.getElementById('tiff-to-png-converter');
if (root) {
  createApp(TiffToPngConverter).mount('#tiff-to-png-converter');
}
